import { useState } from "react";

const TierLabel: Record<number, string> = {
  1: "Easy",
  2: "Medium",
  3: "Hard",
  4: "Boss",
  5: "Tier 5",
  6: "Tier 6",
  7: "Tier 7",
};

const FallbackEmoji: Record<number, string> = {
  1: "🟢",
  2: "🟡",
  3: "🟠",
  4: "🔴",
  5: "💀",
  6: "👹",
  7: "🐲",
};

// Heraldic shield for camp tier. Renders inside a square slot so the
// painterly shield image keeps its natural look without being stretched.
export function TierShield({
  tier,
  size = 56,
  className = "",
}: {
  tier: number;
  size?: number;
  className?: string;
}) {
  const [failed, setFailed] = useState(false);
  const safeTier = Math.max(1, Math.min(7, tier));

  if (failed) {
    return (
      <span
        className={className}
        title={TierLabel[safeTier]}
        style={{
          width: size,
          height: size,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: size * 0.65,
          lineHeight: 1,
        }}
      >
        {FallbackEmoji[safeTier]}
      </span>
    );
  }
  return (
    <span
      className={className}
      style={{
        width: size,
        height: size,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <img
        src={`/icons/tiers/tier-${safeTier}.png?v=3`}
        alt={TierLabel[safeTier]}
        title={TierLabel[safeTier]}
        onError={() => setFailed(true)}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
          objectFit: "contain",
        }}
        loading="lazy"
      />
    </span>
  );
}
